<template>
  <!-- 穿梭框组件 getSubordinateList-->
  <div>
    <div class="transfernew">
      <div class="left">
        <h3>选择 <span></span></h3>
        <Input placeholder="搜索" class="left-input" @on-clear="clear" v-model="searvhValue" @on-enter="tosearch" clearable>
        <Icon type="ios-search" slot="prefix" @click="tosearch" />
        </Input>
        <div style="width:100%;height:25px;overflow:hidden;padding:5px;">
          <Breadcrumb separator=">" v-if="sessionParentList.length<=3">
            <Breadcrumb-item v-for="(item,index) in sessionParentList" :key="index" @click.native="getTitle(item,index)">{{item.structureName}}</Breadcrumb-item>

          </Breadcrumb>
          <Breadcrumb separator=">" v-if="sessionParentList.length>3">
            <span>
              <Icon v-show="sessionParentList.length>3" @click="getTitle(sessionParentList[0])" type="ios-arrow-back"></Icon>
            </span>
            <Breadcrumb-item v-for="(item,index) in sessionParentList" :class="{'hahaha' : index==0}" :key="index" @click.native="getTitle(item,index)">
              {{item.structureName}}</Breadcrumb-item>

          </Breadcrumb>
        </div>
        <ul>
          <li v-show="item" v-for="(item,index) in dataleftlist" :key="index">
            <span @click="toright(item,index)" class="span-left">
              <Icon class="icon-i" type="ios-folder"></Icon>{{item.structureName}}
            </span>

            <span @click="todown(item,index)" class="item-span" :class="{'item-span-active' : item.isParent!==0}">
              <Icon type="md-albums"></Icon>下级
            </span>
          </li>
        </ul>
      </div>
      <div class="left right">
        <h3>已选</h3>
        <p class="p"> </p>
        <ul>
          <li v-show="item" v-for="(item,index) in datarightlist" :key="index">
            <Icon class="icon-i" type="ios-folder"></Icon>{{item.structureName}}
            <span class="item-span2" @click="deletitem(item,index)">
              <Icon type="ios-close-circle-outline" /></span>
          </li>
        </ul>
      </div>

    </div>
    <div class="secondBumen-bottom">
      <Button class="btn" type="success" ghost @click="postTarget(1)">取消</Button>
      <Button class="btn sure" :class="{'btns' : this.sessionParentList.length!==0}" type="success" ghost @click="postTarget(2)">确定</Button>
    </div>
  </div>
</template>
<script>
import { getSubordinateList, searchStructionByName } from '../servers/api'
import { log } from 'util';
export default {
  name: 'transfer',
  props: {
    titleObj: Object
  },
  data () {
    return {
      titleListlength: 3,
      titles: ['选择', '已选'],//标题集合
      datalist: [],
      cityItem: '',
      data: [],
      dataleftlist: [],//左侧展示数组
      datarightlist: [],//右侧数组展示
      searvhValue: '',//搜索值
      sessionParentList: [],
      name: {}
    }
  },
  created () {
  },
  methods: {
    todown (item, index) {//点击下级
      let params = {
        structureId: item.id
      }
      if (item.isParent !== 0) {
        getSubordinateList(params).then(res => {
          if (res.data.code == 1) {
            this.dataleftlist = res.data.data.childList || [];
            this.sessionParentList = res.data.data.parentList;//存储父级列表
            this.sessionParentList.reverse();
            this.titleListlength = this.sessionParentList.length;
          }

        })
      }
    },
    clear () {//清楚搜索框内容
      this.getTitleone(this.titleObj, this.name);
    },
    toright (item, index) {//左侧插入右侧
      this.datarightlist = [];

      this.datarightlist.push(item)
      this.name = this.datarightlist[0];
    },
    deletitem (item, index) {//删除右侧
      this.datarightlist = []
    },
    getTitleone (item, name, selected) {//获取树形点击得参数 item,name是修改的信息和父级的信息 this.titleObj是修改的信息
      this.datarightlist = [];
      if (name && name.structureName) {
        this.name = name;
      }

      // console.log(item,name,this.titleObj)//父级1-1  统计111和1-1-111
      getSubordinateList({ structureId: name.id }).then(res => {//查询当前修改的部门父级部门的下级部门

        if (res.data.code == 1) {
          this.dataleftlist = res.data.data.childList || [];//左侧的列表是包括自己的列表
          if (res.data.data.parentList.length > 0) {
            this.sessionParentList = res.data.data.parentList;//存储父级列表
            this.sessionParentList.reverse();//给列表倒叙
            let sessionId = '';//父级i
            if (selected && selected.id) {
              this.datarightlist.push(selected);//右侧是上级部门
            } else {
              this.datarightlist.push(name);//右侧是上级部门
            }

          }
        }

      })
    },
    tosearch () { //搜索
      if (this.searvhValue !== '') {
        let params = {
          name: encodeURIComponent(this.searvhValue, "utf-8")
        }
        searchStructionByName(params).then(res => {
          if (res.data.code == 1) {
            this.dataleftlist = res.data.data
          }
        })
      }
    },
    getTitle (item, index) {//点击tab
      this.todown(item, index)
    },
    postTarget (index) {//提交穿梭框
      if (index == 1) {
        this.$emit('setbumenModal', false)//关闭本组件弹窗
      } else {
        if (this.datarightlist.length > 0) {
          this.$emit('setData', this.datarightlist[0]);//传得是上级部门选项
          this.$emit('setbumenModal', false);//关闭本组件弹窗
        }
      }

    },
  }
}
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";

.ivu-breadcrumb > span {
  color: #53cac3;
  cursor: pointer;
}
.btns {
  color: #fff;
  background: #53cac3;
}

.ivu-breadcrumb /deep/ .ivu-breadcrumb-item-separator {
  margin: 0 2px;
}
.secondBumen-bottom {
  font-family: SimHei;
  width: 100%;
  margin-top: 15px;
  text-align: center;
  .btn {
    margin-right: 15px;
  }
}
.ivu-breadcrumb .hahaha {
  display: none;
}
.ivu-breadcrumb > span:last-child {
  color: #7f7f7f;
}
.transfernew {
  cursor: pointer;
  font-family: SimHei;
  font-size: 13px;
  width: 700px;
  height: 450px;
  .right {
    margin-left: 15px;
  }
  .left {
    width: 327px;
    height: 450px;
    border: 1px solid #53cac3;
    border-radius: 5px;
    float: left;
    h3 {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding-left: 15px;
      border-bottom: 1px solid #53cac3;
    }
    .left-input {
      width: 255px;
      margin-left: 15px;
      margin-top: 15px;
    }
    .p {
      padding-left: 15px;
      margin-top: 5px;
      height: 35px;
      width: 100%;
      span i {
        color: #53cac3;
      }
    }
    ul {
      height: 260px;
      overflow: hidden;
      overflow-y: scroll;
      width: 100%;
      padding-left: 15px;
      line-height: 30px;
      li {
        display: inline-block;
        width: 100%;
        padding-left: 15px;
        line-height: 20px;
      }
      .icon-i {
        margin-right: 5px;
      }
      .span-left {
        width: 200px;
        display: inline-block;
      }
      .item-span {
        display: inline-block;
        width: 80px;
        float: right;
        height: 100%;
        border-left: 1px solid #d7d7d7;
        padding-left: 15px;
      }
      .item-span-active {
        color: #53cac3;
      }
      .item-span2 {
        width: 20px;
        height: 100%;
        float: right;
        margin-right: 15px;
      }
    }
    ul::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/tan/transfer.vue